import { LegalLayout } from './LegalLayout';
import { BOOK_AUTHOR, BOOK_TITLE, SITE_URL } from '../../lib/constants';

export function Terms() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="April 30, 2026">
      <p>
        These Terms of Service ("Terms") govern your use of{' '}
        <a href={SITE_URL}>{SITE_URL.replace('https://', '')}</a> (the "Site"),
        operated by {BOOK_AUTHOR}. By using the Site, you agree to these Terms.
      </p>

      <h2>The book</h2>
      <p>
        <em>{BOOK_TITLE}</em> is a personal-finance guide intended for general
        educational purposes. It is not financial, legal, tax, or investment
        advice. Your situation is specific to you; consult a licensed professional
        before making decisions that materially affect your finances.
      </p>

      <h2>Purchases</h2>
      <p>
        eBook and paperback purchases are completed on Amazon and are subject to
        Amazon's terms and conditions, including Amazon's pricing, delivery, and
        return policies. We do not process or store your payment information.
      </p>

      <h2>Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Reproduce, redistribute, or resell the book or any substantial portion of it without permission.</li>
        <li>Attempt to interfere with the Site, including via automated scraping, denial-of-service, or probing for vulnerabilities.</li>
        <li>Submit false, abusive, or unlawful content (for example, on the leaderboard or contact form).</li>
      </ul>

      <h2>Intellectual property</h2>
      <p>
        All content on the Site — including the book text, cover art, illustrations,
        and design — is owned by {BOOK_AUTHOR} or licensed to us. You receive a
        non-transferable license to read the book for personal, non-commercial use.
      </p>

      <h2>Third-party links</h2>
      <p>
        The Site links to third-party services (e.g., Amazon). We are not
        responsible for the content, policies, or practices of those services.
      </p>

      <h2>Disclaimers</h2>
      <p>
        The Site and the book are provided "as is" without warranties of any kind,
        express or implied, including merchantability, fitness for a particular
        purpose, and non-infringement. We do not warrant that the Site will be
        uninterrupted or error-free.
      </p>

      <h2>Limitation of liability</h2>
      <p>
        To the fullest extent permitted by law, {BOOK_AUTHOR} will not be liable
        for any indirect, incidental, special, consequential, or punitive damages
        arising out of or related to your use of the Site or the book. Our total
        liability for any claim related to the Site is limited to the amount you
        paid us, if any, in the twelve months preceding the claim.
      </p>

      <h2>Governing law</h2>
      <p>
        These Terms are governed by the laws of the United States and the state in
        which {BOOK_AUTHOR} resides, without regard to conflict-of-law principles.
      </p>

      <h2>Changes</h2>
      <p>
        We may revise these Terms from time to time. Continued use of the Site
        after revisions take effect constitutes acceptance of the updated Terms.
      </p>

      <h2>Contact</h2>
      <p>
        Questions about these Terms?{' '}
        <a href="mailto:support@moneyskillsbook.com">support@moneyskillsbook.com</a>.
      </p>
    </LegalLayout>
  );
}
